import { useState } from 'react';
import { ICartEngraving, IKitInfo } from '~domain/entities/CartItem/ICartItem';
import { deleteEngraving } from '~api/Engraving/DeleteEngraving';

interface IEngravingHook {
    engraving: ICartEngraving;
    kitInfo: IKitInfo;
}

export const useEngraving = ({ engraving, kitInfo }: IEngravingHook) => {
    const {
        selectedFont,
        message,
        price: originalPrice,
        discountedUnitPriceWithTax: discountedPrice,
        discountPercent: productDiscount
    } = engraving;

    const { cartId, collection } = kitInfo;
    const selectedFontClassName = `engrave-choice-${selectedFont?.toLocaleLowerCase()}`;

    const [isLoading, setIsLoading] = useState(false);

    const removeItem = async () => {
        setIsLoading(true);
        await deleteEngraving({
            cartId,
            engraving,
            collection
        });
        setIsLoading(false);
        // @ts-ignore
        emit(events.CART_UPDATED, { newDisplayState: true, newVisibility: true });
    };

    return {
        message,
        isLoading,
        removeItem,
        priceDetails: { originalPrice: originalPrice ?? 0, discountedPrice, productDiscount },
        selectedFontClassName
    };
};
